import { Link } from '@vkontakte/vkui';
import React, { HTMLAttributes } from 'react';
import { useFallbackSearchUrl } from 'reactApp/hooks/useFallbackSearchUrl';

import { BaseMessage } from '../BaseMessage/BaseMessage';
import styles from './ErrorSearch.css';
import { ReloadButton } from './ReloadButton/ReloadButton';

interface IProps extends HTMLAttributes<HTMLDivElement> {
    isMobile?: boolean;
}

export const ErrorSearch: React.FC<IProps> = ({ isMobile = false, ...props }) => {
    const { closeSearch } = useFallbackSearchUrl();

    return (
        <>
            <BaseMessage
                img={<div className={styles.image} />}
                title="Не удалось выполнить поиск"
                text={
                    <>
                        Попробуйте обновить страницу через несколько минут или <Link onClick={closeSearch}>сбросьте поиск.</Link>
                    </>
                }
                {...props}
            >
                {!isMobile && <ReloadButton isMobile />}
            </BaseMessage>
            {isMobile && <ReloadButton isMobile />}
        </>
    );
};

ErrorSearch.displayName = 'ErrorSearch';
